import React from 'react';
import './UrlInput.css';

const UrlInput = ({
  playlistUrl,
  setPlaylistUrl,
  resolvedUrlTitle,
  isUrlInputFocused,
  setIsUrlInputFocused,
  isHistoryOpen,
  setIsHistoryOpen,
  urlHistory,
  setUrlHistory,
  fetchVideos,
  loading,
  filterInstructions,
}) => {
  const handleHistoryItemClick = (item) => {
    setPlaylistUrl(item.url);
    setIsHistoryOpen(false);
    fetchVideos(item.url, filterInstructions);
  };

  const handleClearHistoryItem = (e, itemToClear) => {
    e.stopPropagation();
    const updatedHistory = urlHistory.filter(item => item.url !== itemToClear.url);
    setUrlHistory(updatedHistory);
  };

  return (
    <div className="url-input-container">
      <div className="input-wrapper">
        {playlistUrl && (
          <button className="clear-btn-left" onClick={() => setPlaylistUrl('')}>
            &times;
          </button>
        )}
        <input
          type="text"
          value={isUrlInputFocused ? playlistUrl : resolvedUrlTitle || playlistUrl}
          onFocus={() => {
            setIsUrlInputFocused(true);
            setIsHistoryOpen(true);
          }}
          onBlur={() => {
            setIsUrlInputFocused(false);
            setTimeout(() => setIsHistoryOpen(false), 200); // Delay to allow click on history item
          }}
          onChange={(e) => {
            setPlaylistUrl(e.target.value);
          }}
          placeholder="Enter YouTube Playlist or Video URL"
        />
        <button onClick={() => fetchVideos(playlistUrl, filterInstructions)} disabled={loading}>
          {loading ? 'Loading...' : 'Fetch Videos'}
        </button>
      </div>
      {isHistoryOpen && urlHistory.length > 0 && (
        <div className="history-dropdown">
          {urlHistory.map((item, index) => (
            <div
              key={index}
              className="history-item"
              onClick={() => handleHistoryItemClick(item)}
            >
              <span className="history-item-title">{item.title}</span>
              <button
                className="clear-history-item-btn"
                onClick={(e) => handleClearHistoryItem(e, item)}
              >
                &times;
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default UrlInput;
